<template>
  <BApp id="app">
    <router-view />
    <footer>
      <div class="bg-primary text-white text-center p-3 footer__content">
        <div class="footer__copyright">
          <span class="d-none d-sm-inline">{{ version }} Copyright: </span>© 2021
          <a class="text-light" href="mailto:thflori@gmail.com">Thomas Flori</a>
        </div>
        <div class="footer__social">
          <a class="text-light" href="https://github.com/tflori"><Icon icon="bi:github" /></a>
          <a class="text-light" href="https://packagist.org/packages/tflori/"><Icon icon="bi:box-seam" /></a>
          <a class="text-light" href="https://www.linkedin.com/in/thomas-flori-71a640216/"><Icon icon="bi:linkedin" /></a>
        </div>
      </div>
    </footer>
  </BApp>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, nextTick } from 'vue'
import { Icon } from '@iconify/vue'
import { CookieManager } from '@/tools/CookieManager'
import { updateWindowWidth, updateScreenHeightFromVisualViewport, updateScreenHeightFromInnerHeight, updateScreenWidthFromVisualViewport, updateScreenWidthFromInnerWidth } from '@/stores/ui'
import { checkAuth } from '@/stores/auth'
import { fetchConfig } from '@/stores/config'
import {BApp} from "bootstrap-vue-next";

const version = __APP_VERSION__

function onResize() {
  updateWindowWidth(window.innerWidth)
}

function onOrientationChange() {
  window.addEventListener('resize', () => {
    updateScreenHeightFromInnerHeight()
    updateScreenWidthFromInnerWidth()
  }, { once: true })
}

onMounted(async () => {
  const hashMatch = location.hash.match(/code=([a-zA-Z0-9]+)/)
  if (hashMatch) CookieManager.addShareCode(hashMatch[1])

  const params = new URLSearchParams(location.search)
  if (params.has('code')) CookieManager.addShareCode(params.get('code') ?? '')

  await checkAuth()
  await fetchConfig()

  nextTick(() => {
    window.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', onOrientationChange)
    window.visualViewport?.addEventListener('resize', updateScreenHeightFromVisualViewport)
    window.visualViewport?.addEventListener('resize', updateScreenWidthFromVisualViewport)
  })
})

onUnmounted(() => {
  window.removeEventListener('resize', onResize)
  window.removeEventListener('orientationchange', onOrientationChange)
  window.visualViewport?.removeEventListener('resize', updateScreenHeightFromVisualViewport)
  window.visualViewport?.removeEventListener('resize', updateScreenWidthFromVisualViewport)
})
</script>

<style lang="scss">
@use 'sass:color';
@import './main.scss';
@import 'bootstrap/scss/bootstrap';
@import 'bootstrap-vue-next/src/styles/styles.scss';

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active {
  background-color: $primary;
  border-color: color.adjust($primary, $lightness: -0.2%);
}

.fab-container {
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 50;
}

.btn.btn-fab {
  height: 3rem;
  width: 3rem;
  overflow: hidden;
  border-radius: calc(3rem / 2);
  margin-top: 1rem;
  line-height: 0;
  padding: 0;

  &.btn-lg {
    height: 3.5rem;
    width: 3.5rem;
    border-radius: calc(3.5rem / 2);
  }

  &.btn-sm {
    height: 2.5rem;
    width: 2.5rem;
    border-radius: calc(2.5rem / 2);
  }
}

.dropdown-menu {
  color: #333;

  form {
    margin: 0.5rem;
  }
}

mark, .mark {
  color: #fff;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

footer {
  margin-top: auto;

  .footer__content {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .footer__copyright {
    margin-right: 1em;
  }

  .footer__social a {
    padding: 1em;
  }
}
</style>
